<ion-content [fullscreen]="true" class="cropper-content" *ngIf="base64String && loaded">
  <div class="cropper-wrapper">
    <ion-img [src]="base64String" class="cropper-img" alt="Imagem selecionada para edição"></ion-img>
  </div>
</ion-content>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-footer translucent *ngIf="base64String && loaded">
  <ion-toolbar class="cropper-toolbar">
    <div class="action-buttons">
      <div class="action-button" (click)="save()">
        <div class="icon-circle">
          <i class="fas fa-paper-plane"></i>
        </div>
        <span>Salvar</span>
      </div>

      <div class="action-button" (click)="editPhoto()">
        <div class="icon-circle">
          <i class="fas fa-cut"></i>
        </div>
        <span>Editar</span>
      </div>

      <div class="action-button" (click)="cancel()">
        <div class="icon-circle">
          <i class="fas fa-times"></i>
        </div>
        <span>Cancelar</span>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>